@if (isDesk$ | async) {
  <p-calendar
    #datepicker
    [(ngModel)]="date"
    inline="true"
    [selectionMode]="isRange() ? 'range' : 'single'"
    (click)="onClickCalendar()"
    (onSelect)="onDateSelect()"
    [readonlyInput]="true"
    [minDate]="minDateInput()"
    [maxDate]="maxDateInput()"
    [showOtherMonths]="false"
    [disabled]="disabled()"
  ></p-calendar>
} @else {
  @if (isRange()) {
    <p-calendar
      #datepicker
      [(ngModel)]="date"
      inline="true"
      [selectionMode]="'range'"
      (click)="onClickCalendar()"
      (onSelect)="onDateSelect()"
      [readonlyInput]="true"
      [minDate]="minDateInput()"
      [maxDate]="maxDateInput()"
      [showOtherMonths]="false"
      [numberOfMonths]="12"
      [disabled]="disabled()"
    ></p-calendar>
  } @else {
    <p-calendar
      #datepicker
      [(ngModel)]="date"
      inline="true"
      [selectionMode]="'single'"
      (click)="onClickCalendar()"
      (onSelect)="onDateSelect()"
      [readonlyInput]="true"
      [minDate]="minDateInput()"
      [maxDate]="maxDateInput()"
      [showOtherMonths]="false"
      [disabled]="disabled()"
    ></p-calendar>
  }
}
